/**
 * baseForm 配置文件
 */
import { checkMobilePhone, isEmail } from '@/utils/validate'

const validatePhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入11位手机号码'))
  } else if (!checkMobilePhone(value)) {
    callback(new Error('请输入正确的手机号码'))
  }
  callback()
}

const validateEmail = (rule, value, callback) => {
  if (!isEmail(value)) {
    callback(new Error('请输入正确的邮箱地址'))
  }
  callback()
}

// 校验著作人
const validateAuthors = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入著作权人信息'))
  } else if (typeof value === 'string' && JSON.parse(value).length == 0) {
    callback(new Error('请输入著作权人信息'))
  }
  callback()
}

export const rules = {
  'fullName.data': [{ required: true, message: '请输入软件全称', trigger: 'blur' }],
  // 'shortName.data': [{ required: true, message: '请输入软件简称', trigger: 'blur' }],
  'versionNo.data': [{ required: true, message: '请输入版本号', trigger: 'blur' }],
  'category.data': [{ required: true, message: '请选择软件分类', trigger: 'change' }],
  'completionDate.data': [{ required: true, message: '请选择开发完成日期', trigger: 'change' }],
  'publishState.data': [{ required: true, message: '请选择发表状态', trigger: 'change' }],
  'firstPublishDate.data': [{ required: true, message: '请选择首次发表日期', trigger: 'change' }],
  'firstPublishAddress.data': [{ required: true, message: '请选择首次发表地址', trigger: 'change' }],
  'developHardware.data': [{ required: true, message: '请输入开发硬件环境', trigger: 'blur' }],
  'productHardware.data': [{ required: true, message: '请输入运行硬件环境', trigger: 'blur' }],
  'developOs.data': [{ required: true, message: '请输入开发操作系统', trigger: 'blur' }],
  'developTools.data': [{ required: true, message: '请输入软件开发环境', trigger: 'blur' }],
  'operatingPlatform.data': [{ required: true, message: '请输入软件运行平台', trigger: 'blur' }],
  'supportingEnv.data': [{ required: true, message: '请输入软件支撑环境', trigger: 'blur' }],
  'programmingLanguage.data': [{ required: true, message: '请输入编程语言', trigger: 'blur' }],
  'sourceCodeCount.data': [{ required: true, message: '请输入源程序量', trigger: 'blur' }],
  'developPurpose.data': [{ required: true, message: '请输入开发目的', trigger: 'blur' }],
  'fieldOriented.data': [{ required: true, message: '请输入面向领域', trigger: 'blur' }],
  'attributes.data': [{ required: true, message: '请选择软件属性', trigger: 'change' }],
  'primaryFunction.data': [{ required: true, message: '请输入软件主要功能', trigger: 'blur' }],
  'technicalFeature.data': [{ required: true, message: '请输入软件技术特点', trigger: 'blur' }],
  'authors.data': [
    { required: true, message: '请输入著作权人信息', trigger: 'blur' },
    { validator: validateAuthors, message: '请输入著作权人信息', trigger: 'blur' }
  ],
  'contactPerson.data': [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
  'postalAddress.data': [{ required: true, message: '请选择邮寄地址', trigger: 'change' }],
  'postalAddressPrecise.data': [{ required: true, message: '请输入准确的邮寄地址', trigger: 'blur' }],
  'postalCode.data': [{ required: true, message: '请输入所在行政区县的邮政编码', trigger: 'blur' }],
  'contactPhone.data': [
    { required: true, message: '请输入11位手机号码', trigger: 'blur' },
    { validator: validatePhone, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  'contactEmail.data': [
    { required: true, message: '请输入常用邮箱，重要官文会通过邮件通知', trigger: 'blur' },
    { validator: validateEmail, trigger: 'blur' }
  ],
  'softwareDocument.data': [{ required: true, message: '请上传软件说明文档', trigger: 'blur' }],
  'includingEnglish.data': [{ required: true, message: '请选择说明书是否含有英文', trigger: 'change' }],
  'scoreCode.data': [{ required: true, message: '请上传软件源代码', trigger: 'change' }],
  'cooperativeAgreement.data': [{ required: true, message: '请上传合作开发协议', trigger: 'change' }],
  'nameExplanation.data': [{ required: true, message: '请上传名称英文解释', trigger: 'change' }],
  'manualExplanation.data': [{ required: true, message: '请上传说明书英文解释', trigger: 'change' }]
}

// 表格配置
export const columns = [
  {
    title: '著作权人名称',
    dataIndex: 'ownerName',
    key: 'ownerName'
  },
  {
    title: '类型',
    dataIndex: 'category',
    key: 'category',
    align: 'center',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '纳税号/身份证号',
    dataIndex: 'socialCreditCode',
    key: 'socialCreditCode',
    scopedSlots: { customRender: 'socialCreditCode' }
  },
  {
    title: '操作',
    dataIndex: 'aaa',
    key: 'aaa',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export const rules1 = {
  ownerName: [{ required: true, message: '请输入与营业执照一致的公司名称', trigger: 'change' }],
  socialCreditCode: [{ required: true, message: '请输入企业统一社会信用代码', trigger: 'blur' }],
  companyFoundDate: [{ required: true, message: '请选择公司成立日期', trigger: 'change' }],
  certified: [{ required: true, message: '请上传证明文件', trigger: 'change' }],
  developInstruction: [{ required: true, message: '请上传前期开发说明', trigger: 'change' }],
  technicianCertified: [{ required: true, message: '请上传技术员身份证明', trigger: 'change' }]
}

export const rules2 = {
  ownerName: [{ required: true, message: '请输入与营业执照一致的公司名称', trigger: 'change' }],
  socialCreditCode: [{ required: true, message: '请输入企业统一社会信用代码', trigger: 'blur' }],
  validPeriodStart: [{ required: true, message: '请选择有效日期', trigger: 'change' }],
  certified: [{ required: true, message: '请上传证明文件', trigger: 'change' }]
}

export const rules3 = {
  ownerName: [{ required: true, message: '请输入与营业执照一致的公司名称', trigger: 'change' }],
  socialCreditCode: [{ required: true, message: '请输入企业统一社会信用代码', trigger: 'blur' }],
  companyFoundDate: [{ required: true, message: '请选择公司成立日期', trigger: 'change' }],
  branchBusinessLicense: [{ required: true, message: '请上传分公司营业执照', trigger: 'change' }],
  superiorBusinessLicense: [{ required: true, message: '请上传上级单位营业执照', trigger: 'change' }],
  legalPersonsCretified: [{ required: true, message: '请上传上级单位法人证明', trigger: 'change' }]
}

export const rules4 = {
  ownerName: [{ required: true, message: '请输入个人姓名', trigger: 'blur' }],
  idCard: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }],
  identityIdCardCertified: [{ required: true, message: '请上传身份证明', trigger: 'change' }]
}

export const rules5 = {
  ownerName: [{ required: true, message: '请输入个人姓名', trigger: 'blur' }],
  idCard: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }],
  identityIdCardCertified: [{ required: true, message: '请上传身份证明', trigger: 'change' }],
  guardianSignCertified: [{ required: true, message: '请上传监护人签字证明', trigger: 'change' }],
  guardianIdCardCretified: [{ required: true, message: '请上传监护人身份证明', trigger: 'change' }],
  hukouCertifiedApplicant: [{ required: true, message: '请上传请人户口本所在页', trigger: 'change' }],
  hukouCertifiedGuardian: [{ required: true, message: '请上传监护人户口本所在页', trigger: 'change' }],
  hukouCertifiedHomePage: [{ required: true, message: '请上传户口本主页', trigger: 'change' }]
}

// 著作人实体类
export class FormTemplate {
  constructor(category) {
    this.category = category
  }

  caseNo = '' // 案件编号
  category = '' // 著作权人类别
  ownerName = undefined // 企业名称/个人名称/单位名称
  socialCreditCode = '' // 社会信用代码
  idCard = '' // 身份证号码
  companyFoundDate = '' // 公司成立日期
  certified = '' // 证明文件
  developInstruction = '' // 前期开发说明
  technicianCertified = [] // 技术员证名文件
  validPeriodStart = '' // 有效期-起始
  validPeriodEnd = '' // 有效期-截止
  branchBusinessLicense = '' // 营业执照(分公司)
  superiorBusinessLicense = '' // 上级单位营业执照
  legalPersonsCretified = '' // 上级单位法人证明
  identityIdCardCertified = '' // 身份证明
  guardianSignCertified = '' //  监护人签字证明
  guardianIdCardCretified = '' //  监护人身份证明
  hukouCertifiedApplicant = '' //  户口证明-申请人户口本所在页
  hukouCertifiedGuardian = '' //  户口证明-监护人户口本所在页
  hukouCertifiedHomePage = '' //  户口证明-户口本主页
  attachment = '' //  附件
}
